import React, { Component } from "react";
import { Segment, Input, Button, Icon, Dropdown } from "semantic-ui-react";
import { getTodayJalaali } from "../utils/jalaaliUtils";
import DatePickerModal from "../utils/DatePickerModal";

class BillFilter extends Component {
  state = {
    dateRange: this.props.dateRange || {
      fromDate: getTodayJalaali(),
      toDate: getTodayJalaali(),
    },
    calendarIsOpen: false,
    paymentTypeOptions: [
      { key: "", text: "هیچکدام", value: "" },
      { key: "cash", text: "نقدی", value: "cash" },
      { key: "card", text: "کارتی", value: "card" },
      { key: "cheque", text: "چک", value: "cheque" },
    ],
    selectedPaymentType: null,
    billStatusOptions: [
      { key: "", text: "هیچکدام", value: "" },
      { key: "active", text: "فعال", value: "active" },
      { key: "remained", text: "باقی مانده", value: "remained" },
      { key: "done", text: "بسته شده", value: "done" },
    ],
    selectedBillStatus: null,
  };

  handleCalendarClick = (status) => {
    this.setState({
      calendarIsOpen: status,
    });
  };

  setDate = (choosenFrom, choosenTo) => {
    let from = `${choosenFrom.year}-${choosenFrom.month}-${choosenFrom.day}`;
    let to = `${choosenTo.year}-${choosenTo.month}-${choosenTo.day}`;
    this.setState({
      dateRange: {
        fromDate: from,
        toDate: to,
      },
      calendarIsOpen: false,
    });
  };

  handlePaymentTypeChange = (event, data) => {
    this.setState({ selectedPaymentType: data.value });
  };

  handleBillStatusChange = (event, data) => {
    this.setState({ selectedBillStatus: data.value });
  };

  handleFetchData = () => {
    // Notify parent component about date change
    this.props.onDataChange(
      this.state.dateRange.fromDate, 
      this.state.dateRange.toDate,
      this.state.selectedPaymentType,
      this.state.selectedBillStatus
    );
    this.props.onFetchData();
  };

  render() {
    const {
      paymentTypeOptions,
      selectedPaymentType,
      billStatusOptions,
      selectedBillStatus,
    } = this.state;
    return (
      <React.Fragment>
        <Segment stacked className="rtl">
          <React.Fragment id="r-form">
            <span className="r-form-span-padding">از تاریخ</span>
            <Input
              value={this.state.dateRange.fromDate}
              className="r-input"
              readOnly
            />
            <span className="r-form-span-padding">تا تاریخ</span>
            <Input
              value={this.state.dateRange.toDate}
              className="r-input"
              readOnly
            />
            <Icon
              onClick={() => this.handleCalendarClick(true)}
              name="calendar alternate outline"
              color="teal"
              size="big"
              className="date-picker-icon"
            />
            {/* Payment Type Filter */}
            <Dropdown
              placeholder="انتخاب نوع پرداخت"
              selection
              options={paymentTypeOptions}
              onChange={this.handlePaymentTypeChange}
              value={selectedPaymentType}
            />

            {/* Bill Status Filter */}
            <Dropdown
              placeholder="انتخاب وضعیت فاکتور"
              selection
              options={billStatusOptions}
              onChange={this.handleBillStatusChange}
              value={selectedBillStatus}
            />
            <Button
              className="yekan"
              icon
              color="yellow"
              onClick={this.handleFetchData}
              labelPosition="right"
            >
              <span>نمایش گزارش</span>
              <Icon name="search" />
            </Button>
          </React.Fragment>
        </Segment>
        <DatePickerModal
          onClose={() => this.handleCalendarClick(false)}
          isOpen={this.state.calendarIsOpen}
          setDate={this.setDate}
        />
      </React.Fragment>
    );
  }
}

export default BillFilter;
